module.exports = __webpack_public_path__ + "static/media/closeZoom.5e3052c6.svg";